import React from "react";

const CommentCard = ({ req }) => {
  return (
    <>
      <div>
        <div
          style={{
            fontSize: 12,
            fontWeight: "bold",
            opacity: 0.6,
            marginBottom: 5,
          }}
        >
          USER
        </div>
        <div
          style={{
            display: "flex",

            justifyContent: "flex",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 15,
          }}
        >
          {req.comment.user}
        </div>
      </div>
      <div>
        <div
          style={{
            fontSize: 12,
            fontWeight: "bold",
            opacity: 0.6,
            marginBottom: 3,
            marginTop: 3,
          }}
        >
          Agent
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 15,
          }}
        >
          {req.comment.agent}
        </div>
      </div>
      <div
        style={{ position: "absolute", right: 10, top: 10, textAlign: "right" }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: "bold",
            opacity: 0.6,
            marginBottom: 5,
          }}
        >
          Date
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 15,
          }}
        >
          {req.comment.commentDateTime}
        </div>
      </div>
      <div>
        <div
          style={{
            fontSize: 12,
            fontWeight: "bold",
            opacity: 0.6,
            marginBottom: 3,
            marginTop: 3,
          }}
        >
          Comment
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 15,
            // marginBottom: 10,
          }}
        >
          {req.comment.comment}
        </div>
      </div>
    </>
  );
};

export default CommentCard;
